import './cateogary.css'
import UseFetch from '../UseFetch'
import mainData from '../FetchDataLinks'
import CateogarySkeleton from './CateogarySkeleton'
import MainCateogary from './MainCateogary'

function CateogaryWise() {
    const { blogs, loading } = UseFetch(`${mainData.randomCateogary}`)
    return (
        <>
            {loading && <CateogarySkeleton />}
            {!loading && blogs.length !== 0 && <MainCateogary blogs={blogs} head={blogs[0].Cateogary} />}
        </>
    )
}

export default CateogaryWise
